import { Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PaymentChip, StatusChip } from '@/components/ui/Chip';
import type { InvoiceListItem } from '@/hooks/useInvoices';
import { invoiceStatusTone } from './invoiceStatusTone';

export function StatusBadge({
  status,
}: {
  status: InvoiceListItem['status'];
  paymentMethod?: string | null;
  totalPaidCents?: number | null;
}) {
  const { t } = useTranslation();
  return <StatusChip tone={invoiceStatusTone(status)}>{t(`invoices.status_${status}`)}</StatusChip>;
}

export function InvoiceStatusBadges({
  status,
  lastSentAt,
  lastReminderSentAt,
}: {
  status: InvoiceListItem['status'];
  lastSentAt?: string | null;
  lastReminderSentAt?: string | null;
  paymentMethod?: string | null;
  totalPaidCents?: number | null;
}) {
  const { t } = useTranslation();
  return (
    <span className="inline-flex flex-wrap items-center gap-s1">
      <StatusBadge status={status} />
      {lastSentAt && status !== 'draft' ? (
        <PaymentChip
          icon={<Mail className="h-3 w-3" aria-hidden />}
        >
          {t('invoices.status_email_sent')}
        </PaymentChip>
      ) : null}
      {lastReminderSentAt && status === 'issued' ? (
        <PaymentChip icon={<Mail className="h-3 w-3" aria-hidden />}>
          {t('invoices.status_reminder_sent')}
        </PaymentChip>
      ) : null}
    </span>
  );
}
